import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Stack from 'react-bootstrap/Stack'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { TextInput, IconButton } from '/src/components/common'
import { postRequest } from '/src/httpClient'

export const ForgotPasswordForm = () => {
  const { register, formState: { errors }, handleSubmit } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState(false)

  const onSubmit = (data) => {
    setIsLoading(true)

    postRequest('/api/user/password', {mail: data.email}).then(res => {
      setIsLoading(false)
      
      if (res) {
        setMessage('Password reset request successfully sent.')
      }
      else {
        setMessage('Password reset request was sent.')
      }
    })
  }

  return (
    <div className="login-form-container">
      <form id="forgot-password-form" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-4">
          {message !== false && (
            <Col sm={12}>
              <p>{message}</p>
            </Col>
          )}
          <Col sm={12}>
            <TextInput label="Email" type="text" error={errors.email} register={register('email', {
              required: true,
              pattern: {
                value: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                message: 'Please provide a valid email address'
              }
            })} />
          </Col>
        </Row>
        <Row>
          <Stack direction="horizontal" gap={4}>
            <IconButton type="submit" icon={faArrowRight} disabled={isLoading}>
              {isLoading ? 'Checking...' : 'Reset Password'}
            </IconButton>
            <Link className="link forgot-password-link" to="/user/login">
              <FontAwesomeIcon icon={faQuestionCircle} />
              Login
            </Link>
          </Stack>
        </Row>
      </form>
    </div>
  )
}

export default ForgotPasswordForm